export default "__VITE_ASSET__Bu7lSXBi__"